<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "ABOUT_US.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card class="mat-elevation-z0">
    <mat-card-content>
        <div>
            <img src="assets/images/logo-secondary.png" alt="Logo" />
        </div>
        <p>
            {{ "ABOUT_US.GURUMATCH.PART1" | translate }}
        </p>
        <p>
            {{ "ABOUT_US.GURUMATCH.PART2" | translate }}
        </p>
        <p>
            {{ "ABOUT_US.GURUMATCH.PART3" | translate }}
        </p>
        <p>
            {{ "ABOUT_US.GURUMATCH.PART4" | translate }}
        </p>
        <p>
            {{ "ABOUT_US.GURUMATCH.PART5" | translate }}
        </p>
    </mat-card-content>
</mat-card>
